import { render, staticRenderFns } from "./cDataCaptureDocumentRole.vue?vue&type=template&id=277fe9f0&scoped=true"
import script from "./cDataCaptureDocumentRole.vue?vue&type=script&lang=js"
export * from "./cDataCaptureDocumentRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277fe9f0",
  null
  
)

export default component.exports